import { HttpEvent, HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ClientLogService } from './client-log.service';

/**
 * Reports failed backend calls (network errors and 5xx) to the log sink so they
 * surface in CloudWatch. Skips the sink endpoint to avoid a loop and skips
 * expected 4xx (validation/auth) to keep noise down.
 */
@Injectable()
export class ClientLogInterceptor implements HttpInterceptor {
  constructor(private readonly logger: ClientLogService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/client-log')) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      tap({
        error: (err) => {
          if (err instanceof HttpErrorResponse && (err.status === 0 || err.status >= 500)) {
            this.logger.log('error', `HTTP ${err.status} ${req.method} ${req.url} - ${err.message}`);
          }
        },
      })
    );
  }
}
